<template>
  <div class="equipment">
    <PageTopNav :tabsShow3="true" @changeTab3="changeTab3" :tabList3="tabList3" :changeIndex3="changeIndex3" />
    <router-view></router-view>
    <MyNav />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getEquipmentGroupApi } from '@/request/api'

export default {
  components: {
    MyNav: () => import('@/components/MyNav.vue'),
    PageTopNav: () => import('@/components/PageTopNav.vue')
  },
  data() {
    return {
      tabList3: {},
      changeIndex3: 0,
      videoCont: '',
      table_id: '',
      channel_id: ''
    }
  },
  computed: {
    ...mapState({
      farmID: (state) => state.user.farmID
    })
  },
  created() {
    this.channel_id = this.$route.query.id || localStorage.getItem('equipmentId')
    this.getEquipmentGroup(this.$route.query.id)
  },

  methods: {
    ...mapMutations('user', ['SET_EQUIPMENT_Name']),

    async getEquipmentGroup(id) {
      const { code, data } = await getEquipmentGroupApi()
      if (code === 200) {
        this.tabList3 = {
          0: {
            cid: 1,
            id: 1,
            // icon: "dryingPlanList",
            // name: "烘干计划",
            icon: 'dryingList',
            name: '烘干记录',
            children: []
          }
          // 1: {
          //   cid: 1,
          //   id: 2,
          //   icon: 'dryingList',
          //   name: '烘干记录',
          //   children: []
          // },
          // 1: data[4]
        }
        if (!sessionStorage.getItem('equipmentName')) {
          sessionStorage.setItem('equipmentId', data[3].id)
          sessionStorage.setItem('equipmentName', data[3].icon)
        }
        this.changeIndex3 = this.$route.query.id || this.tabList3['0'].id
      }
      if (!id) {
        this.changeTab3({ id: this.changeIndex3, icon: '' })
      }
    },
    changeTab3({ id, icon }) {
      if (id) {
        this.changeIndex3 = id
      }
      sessionStorage.setItem('childTitle3', this.changeIndex3)
      sessionStorage.setItem('equipmentId', id)
      sessionStorage.setItem('equipmentName', icon)
      this.SET_EQUIPMENT_Name({ icon })
      switch (icon) {
        case 'dryingPlanList':
          this.$router.push({
            name: 'dryingPlanList'
          })
          break
        case 'dryingList':
          this.$router.push({
            name: 'dryingList'
          })
          break
        case 'heat':
          this.$router.push({
            name: 'dryingInfo',
            query: { id }
          })
          break
        case '':
          this.$router.push({
            name: 'dryingPlanList'
          })
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.equipment {
  width: 100%;
  min-height: 100vh;
  background-color: #071a2c;
  padding: 62px 0 0;
  color: #fff;
  overflow: hidden;
}
</style>
